import { PageResponse } from '@iapmoit/library.angular.core';
import { AuditorAuditListView } from './auditor.types';

type PageMeta = PageResponse<AuditorAuditListView>['page'];

interface AuditorAuditApiRow {
    auditId: number;
    auditType: string | null;
    clientName: string | null;
    auditStatus: string | null;
    dropDeadDate: string | null;
    startDate: string | null;
    endDate: string | null;
}

export interface AuditorAuditApiResponse {
    items: AuditorAuditApiRow[];
    page: PageMeta;
}

/**
 * Key order is the display order of the auditor audit tables: the shared data
 * table derives its column order from the first row, so it must stay stable.
 */
export const toAuditorAuditListPage = (response: AuditorAuditApiResponse): PageResponse<AuditorAuditListView> => {
    const page = new PageResponse<AuditorAuditListView>();
    page.items = (response?.items ?? []).map(row => ({
        auditId: row.auditId,
        auditNumber: row.auditId,
        auditType: row.auditType,
        clientName: row.clientName,
        auditStatus: row.auditStatus,
        dropDeadDate: row.dropDeadDate,
        startDate: row.startDate,
        endDate: row.endDate,
    }));
    page.page = response?.page;
    page.totalItems = response?.page?.totalItems;
    page.currentPage = response?.page?.currentPage;
    page.itemsPerPage = response?.page?.itemsPerPage;
    page.query = null;
    return page;
};
